// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ny-0";
export var assigneeDetails = "_ny-1";
export var assigneeInfo = "_ny-2";
export var dropdownContainer = "_ny-4";
export var dropdownImage = "_ny-5";
export var editAssigneeInfo = "_ny-3";
export var editAssigneeModalContainer = "_ny-6";
export var hidden = "_ny-8";
export var input = "_ny-7";